// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"b3188d14","139":"f4613e57","442":"80b84c0c","477":"0a3cb0e2","670":"49655123","672":"f20d3e8d","696":"2ab5aa5f","824":"48742759"}[chunkId] + ".chunk.js";
};